import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import 'moment/locale/pt-br';
import 'src/assets/styles/antd.css';
import 'src/assets/styles/main.scss';

import { store, persistor } from 'src/store';
import App from 'src/screens/app/app.component';
import IntlProviderConfigured from 'src/_i18n/provider/provider.component';

import * as serviceWorker from './serviceWorker';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <IntlProviderConfigured>
        <App />
      </IntlProviderConfigured>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
